import {
  parseErrorPayload,
  resolveApiErrorMessage,
  type ParsedErrorPayload,
} from "@kontextwerk/control-web-client"

export { resolveApiErrorMessage }
export type { ParsedApiFieldError, ParsedErrorPayload } from "@kontextwerk/control-web-client"

export const parseApiErrorPayload = async (response: Response): Promise<ParsedErrorPayload> =>
  parseErrorPayload(response)
